import { render } from "./scatter.vue?vue&type=template&id=52ed8734"
import script from "./scatter.vue?vue&type=script&lang=js"
export * from "./scatter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__